import { render, staticRenderFns } from "./CustomerInvoiceList.vue?vue&type=template&id=838babce&scoped=true"
import script from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./CustomerInvoiceList.vue?vue&type=style&index=0&id=838babce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838babce",
  null
  
)

export default component.exports